module.exports = __webpack_public_path__ + "static/img/4areaB_5.1136f0f.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/character2/4areaB_5.png
// module id = 1194
// module chunks = 1